import type { PortfolioOption, PortfolioKey } from './viewModel';

interface PortfolioSelectorProps {
  options: PortfolioOption[];
  value: PortfolioKey;
  onChange: (value: PortfolioKey) => void;
  ariaPrefix: string;
}

export default function PortfolioSelector({
  options,
  value,
  onChange,
  ariaPrefix,
}: PortfolioSelectorProps) {
  return (
    <div className="mtb-portfolio-selector" role="group" aria-label={`${ariaPrefix}选择`}>
      {options.map((option) => (
        <button
          key={option.key}
          type="button"
          className={option.key === value ? 'is-active' : ''}
          aria-label={`${ariaPrefix} ${option.label}`}
          aria-pressed={option.key === value}
          onClick={() => onChange(option.key)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
